export default "__VITE_ASSET__DIfew4Cj__"